<template>
    <div>
        <app-new-breadcrumb :routesName="$t('otherServicesRouteName')"></app-new-breadcrumb>
        <div class="main">
            <div class="description">
                <div class="description-inner">
                <div class="description-text">
                    <h2>{{ $t("otherServicesTitle") }}</h2>
                </div>
                <div class="description-img">
                    <img src="../../../assets/Analize.jpg">
                </div>
                </div>
            </div>
            <div class="main-part">
                <div class="page-inner">
                <div class="big-card">
                    <div class="big-card-title">
                        <i :class="`${$t('otherServicesIcon3')}`"></i>
                        <h3>{{ $t("otherServicesTitle1") }}</h3>
                    </div>
                    <p>{{ $t("otherServicesText1") }}</p>
                </div>
                <div class="big-card">
                    <div class="big-card-title">
                        <i :class="`${$t('otherServicesIcon3')}`"></i>
                        <h3>{{ $t("otherServicesTitle2") }}</h3>
                    </div>
                    <p>{{ $t("otherServicesText2") }}</p>
                    <div class="big-card-btn" v-b-modal.modal-container-fee>{{ $t('downloadEstimate') }}</div>
                </div>
                <b-modal id="modal-container-fee" :title="$t('otherServicesTitle2ModalTitle')"
                    @close="clearproFormaInvoiceFeesObject">
                    <div class="row">
                        <div class="col-md-12 form-group">
                            <input class="form-control" v-model="proFormaInvoiceFees.jib"
                                v-bind:placeholder="$t('uniqeIdentificationNumberShort')"
                                v-bind:class="{ 'validation-error': $v.proFormaInvoiceFees.jib.$error }"
                                v-on:input="$v.proFormaInvoiceFees.jib.$touch()"
                                @input="proFormaInvoiceFeesJibChanged" />
                            <p class="small text-danger m-0"
                                v-if="$v.proFormaInvoiceFees.jib.$dirty && !$v.proFormaInvoiceFees.jib.required">
                                {{
                                    $t('jibIsRequired') }}</p>
                            <p class="small text-danger m-0"
                                v-if="$v.proFormaInvoiceFees.jib.$dirty && (!$v.proFormaInvoiceFees.jib.minLength || !$v.proFormaInvoiceFees.jib.maxLength)">
                                {{ $t('jibLengthError') }}</p>
                            <p class="small text-danger m-0"
                                v-if="$v.proFormaInvoiceFees.jib.$dirty && !$v.proFormaInvoiceFees.jib.numeric">
                                {{
                                    $t('jibAlphabetNotAllowedError') }}</p>
                            <p class="small text-muted m-0" v-if="legalEntityLookupStatus === 'loading'">
                                {{ $t('checkingDataForJIB') }}
                            </p>
                            <p class="small text-success m-0"
                                v-if="legalEntityLookupStatus === 'found' && legalEntityName">{{
                                    legalEntityName }}</p>

                            <div class="alert alert-warning mt-2 mb-0"
                                v-if="legalEntityLookupStatus === 'not_found' && proFormaJibIsValid">
                                <div class="mb-1">
                                    {{ $t('dataNotFoundForJIB') }}
                                </div>
                                <div>
                                    {{ $t('reCheckJIB') }}
                                </div>
                            </div>

                            <div class="alert alert-danger mt-2 mb-0"
                                v-if="legalEntityLookupStatus === 'error' && proFormaJibIsValid">
                                {{ $t('dataForJIBError') }}
                            </div>

                            <!-- <p class="small text-danger m-0"
                                v-else-if="proFormaFee_showLegalEntityStatus && !proFormaFee_showLegalEntityNameOrError">
                                {{
                                    $t('jibErrLegalEntityDoesntExist') }}</p> -->
                        </div>
                        <div class="col-lg-12 form-group">
                            <app-select v-model="proFormaInvoiceFees.type" v-bind:options="proFormaInvoiceOptions"
                                v-bind:reduce="pf => pf.code" v-bind:placeholder="$t('proFormaInvoiceChoose')"
                                class="select2" :disabled="proFormaInvoiceOptions.length == 0">
                            </app-select>
                        </div>
                        <div class="col-lg-12 form-group">
                            <div v-if="proFormaInvoiceFees.type === 'T'" class="denomination-row d-flex mb-2">
                                <span class="denomination-label col-4 p-0">{{ $t("amountKM") }}</span>
                                <div class="quantity-input col-8 p-0">
                                    <input type="number" min="0" class="form-control col-12"
                                        v-model.number="proFormaInvoiceFees.value" :placeholder="$t('amountKM')">
                                    <p class="small text-danger m-0 p-0 col-12" v-if="proFormaInvoiceFees.value < 0">
                                        {{ $t('negativeValueNotAllowed') }}
                                    </p>
                                </div>
                            </div>
                            <div v-if="proFormaInvoiceFees.type === 'M'" class="denomination-row d-flex mb-2">
                                <span class="denomination-label col-4 p-0">{{ $t("quantity") }}</span>
                                <div class="quantity-input col-8 p-0">
                                    <input type="number" min="0" class="form-control col-12"
                                        v-model.number="proFormaInvoiceFees.quantity" :placeholder="$t('quantity')">
                                    <p class="small text-danger m-0 p-0 col-12" v-if="proFormaInvoiceFees.quantity < 0">
                                        {{ $t('negativeValueNotAllowed') }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 form-group d-flex align-items-center">
                            <span class="denomination-label col-4 p-0">{{ $t("purchaseOrder") }}</span>
                            <div class="quantity-input col-8 p-0">
                                <input class="form-control col-12" v-model="proFormaInvoiceFees.purchaseOrder"
                                    :placeholder="$t('purchaseOrder')">

                            </div>
                        </div>
                        <div class="col-lg-12 form-group denomination-row d-flex align-items-center">
                            <span class="denomination-label col-4 p-0">{{ $t("purchaseOrderDate") }}</span>
                            <div class="quantity-input col-8 p-0">

                                <b-form-datepicker v-model="proFormaInvoiceFees.purchaseOrderDate" :date-format-options="{
                                    day: '2-digit', month: 'numeric', year: 'numeric',
                                }" :placeholder="$t('chooseDate')" locale="hr-HR" class="mb-2"></b-form-datepicker>
                                <p class="small text-danger m-0 p-0 col-12" v-if="$v && $v.proFormaInvoiceFees.purchaseOrderDate.$dirty &&
                                    !$v.proFormaInvoiceFees.purchaseOrderDate.required">
                                    {{ $t('purchaseOrderDateIsRequired') }}
                                </p>
                            </div>
                        </div>

                        <div class="col-lg-12 form-group denomination-row d-flex align-items-center mb-2">
                            <span class="denomination-label col-4 p-0">
                                {{ $t('totalKM') }}
                            </span>
                            <input type="text" class="form-control col-8" :value="totalValue" disabled>
                        </div>

                        <div v-if="legalEntityLookupStatus === 'not_found'" class="col-12">
                            <hr class="my-2" />
                            <h6 class="mb-2">{{ $t('companyDataManualEntry') }}</h6>

                            <div class="alert alert-info mb-2">
                                {{ $t('requiredDataAsterisk') }}
                            </div>

                            <div class="row">
                                <div class="col-md-12 form-group">
                                    <label class="form-label">
                                        {{ $t('legalEntityName') }} <span class="text-danger">*</span>
                                    </label>
                                    <input class="form-control" v-model="manualCompany.legalEntityName"
                                        :placeholder="$t('legalEntityName')">
                                    <p class="small text-danger m-0"
                                        v-if="manualTouched && !manualCompany.legalEntityName">
                                        {{ $t('fieldIsRequired') }}
                                    </p>
                                </div>

                                <div class="col-md-12 form-group">
                                    <label class="form-label">
                                        {{ $t('address') }} <span class="text-danger">*</span>
                                    </label>
                                    <input class="form-control" v-model="manualCompany.address"
                                        :placeholder="$t('address')">
                                    <p class="small text-danger m-0" v-if="manualTouched && !manualCompany.address">
                                        {{ $t('fieldIsRequired') }}
                                    </p>
                                </div>

                                <div class="col-md-12 form-group">
                                    <label class="form-label">
                                        {{ $t('municipality') }} <span class="text-danger">*</span>
                                    </label>
                                    <input class="form-control" v-model="manualCompany.municipality"
                                        :placeholder="$t('municipality')">
                                    <p class="small text-danger m-0"
                                        v-if="manualTouched && !manualCompany.municipality">
                                        {{ $t('fieldIsRequired') }}
                                    </p>
                                </div>

                                <div class="col-md-12 form-group">
                                    <label class="form-label">
                                        {{ $t('taxNumber') }} <span class="text-danger">*</span>
                                    </label>

                                    <input class="form-control" v-model="manualCompany.taxNumber"
                                        :placeholder="$t('taxNumber')" inputmode="numeric" @input="onTaxNumberChanged">

                                    <p class="small text-danger m-0" v-if="manualTouched && !manualCompany.taxNumber">
                                        {{ $t('fieldIsRequired') }}
                                    </p>

                                    <p class="small text-danger m-0"
                                        v-else-if="manualTouched && manualCompany.taxNumber && !manualTaxNumberIsValid()">
                                        {{ $t('taxNumberLengthError') }}
                                    </p>

                                    <p class="small text-muted m-0"
                                        v-else-if="manualCompany.taxNumber && !manualTaxNumberIsValid()">
                                        {{ $t('taxNumberHint') }}
                                    </p>
                                </div>


                                <div class="col-md-12 form-group">
                                    <label class="form-label">
                                        {{ $t('phone') }} <span class="text-danger">*</span>
                                    </label>

                                    <input class="form-control" v-model="manualCompany.phone" :placeholder="$t('phone')"
                                        inputmode="tel" autocomplete="tel" @input="onPhoneChanged">

                                    <p class="small text-danger m-0" v-if="manualTouched && !manualCompany.phone">
                                        {{ $t('fieldIsRequired') }}
                                    </p>

                                    <p class="small text-danger m-0"
                                        v-else-if="manualTouched && manualCompany.phone && !manualPhoneIsValid()">
                                        {{ $t('phoneFormatError') }}
                                    </p>

                                    <p class="small text-muted m-0"
                                        v-else-if="manualCompany.phone && !manualPhoneIsValid()">
                                        {{ $t('phoneFormatHint') }}
                                    </p>
                                </div>

                            </div>
                        </div>

                    </div>
                    <template v-slot:modal-footer>
                        <b-button variant="secondary" @click="$bvModal.hide('modal-container-fee')">
                            {{ $t('cancel') }}
                        </b-button>
                        <b-button variant="primary" @click="downloadEstimate" :disabled="!canDownloadProForma">
                            {{ $t('download') }}
                        </b-button>
                    </template>
                </b-modal>
                <div class="big-card">
                    <div class="big-card-title">
                        <i :class="`${$t('otherServicesIcon3')}`"></i>
                        <h3>{{ $t("otherServicesTitle3") }}</h3>
                    </div>
                    <p>{{ $t("otherServicesText3") }}</p>
                </div>
                <div class="big-card">
                    <div class="big-card-title">
                        <i :class="`${$t('otherServicesIcon3')}`"></i>
                        <h3>{{ $t("otherServicesTitle4") }}</h3>
                    </div>
                    <p>{{ $t("otherServicesText4") }}</p>
                </div>
                <div v-if="getIsAdminOrModerator" class="big-card" v-b-modal.modal-container>
                    <div class="big-card-title">
                        <i :class="`${$t('otherServicesIcon3')}`"></i>
                        <h3>{{ $t("otherServicesTitle5") }}</h3>
                    </div>
                </div>
                <b-modal v-if="getIsAdminOrModerator" id="modal-container" :cancel-title="$t('cancel')"
                    :title="$t('otherServicesTitle5')" @cancel="clearEstimateObject" @close="clearEstimateObject">
                    <div class="row">
                        <div class="col-md-12 form-group">
                            <input v-model="estimate.estimateNumber" :placeholder="$t('estimateNumber')"
                                :class="{ 'validation-error': $v.estimate.estimateNumber.$error }"
                                @input="$v.estimate.estimateNumber.$touch()" @keyup.enter="estimateNumberChanged"
                                type="text" class="form-control" />
                            <p class="small text-danger m-0"
                                v-if="$v.estimate.estimateNumber.$dirty && !$v.estimate.estimateNumber.required">
                                {{ $t('jibIsRequired') }}</p>
                        </div>
                        <!-- <div class="col-md-12 form-group">
                            <input v-model="estimate.legalEntityName" :placeholder="$t('name')" readonly
                                class="form-control" />
                        </div> -->
                        <div class="col-md-12 form-group">
                            <input :value="estimate.legalEntityName || ''" :placeholder="estimateCompanyNamePlaceholder"
                                readonly class="form-control" />

                            <p class="small text-muted m-0" v-if="estimateLookupStatus === 'loading'">
                                {{ $t('loadingCompanyData') }}
                            </p>

                            <div class="alert alert-warning mt-2 mb-0"
                                v-else-if="estimateLookupStatus === 'not_found' && estimate.jib">
                                {{ $t('companyNotInDatabaseEstimateNote') }}
                            </div>

                            <div class="alert alert-danger mt-2 mb-0"
                                v-else-if="estimateLookupStatus === 'error' && estimate.jib">
                                {{ $t('companyLookupError') }}
                            </div>
                        </div>
                        <div class="col-md-12 form-group">
                            <input v-model="estimate.type" :placeholder="$t('estimateType')" readonly
                                class="form-control" />
                        </div>
                        <div class="col-md-12 form-group">
                            <input v-model="estimate.jib" :placeholder="$t('jib')" readonly class="form-control" />
                        </div>
                        <div class="col-md-12 form-group">
                            <input v-model="estimate.downloadDate" :placeholder="$t('downloadDate')" readonly
                                class="form-control" />
                        </div>
                    </div>
                </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Breadcrumb from "../../common/Breadcrumb.vue";
import Select from 'vue-select'
import { required, minLength, maxLength, numeric, requiredIf } from "vuelidate/lib/validators"

export default {
    data() {
        return {
            estimate: {
                jib: null,
                legalEntityId: null,
                downloadDate: null,
                legalEntityName: null,
                estimateNumber: null,
                estimateTypeId: null,
                type: null

            },
            proFormaInvoiceFees: {
                jib: null,
                type: null,
                value: null,
                quantity: null,
                purchaseOrder: null,
                purchaseOrderDate: null,
            },
            manualCompany: {
                legalEntityName: null,
                address: null,
                municipality: null,
                taxNumber: null,
                phone: null,
            },
            proFormaInvoiceOptions: [
                { label: this.$t('fee'), code: 'T' },
                { label: this.$t('billOfExchange'), code: 'M' },
            ],
            legalEntityLookupStatus: "idle",
            estimateLookupStatus: "idle",
            estimateLookupReqId: 0,
            estimateNumberReqId: 0,
            manualTouched: false,
            showSpinner: false,
            isLoading: false,
            legalEntityName: null,
            legalEntityId: null,
            showJibConfirm: false

        }
    },
    validations: {
        estimate: {
            jib: {
                required,
                minLength: minLength(13),
                maxLength: maxLength(13),
                numeric
            },
            estimateNumber: {
                required
            },
            downloadDate: {
                required
            },
        },
        proFormaInvoiceFees: {
            jib: {
                required,
                minLength: minLength(13),
                maxLength: maxLength(13),
                numeric
            },
            type: {
                required
            },
            quantity: {
                required,
                numeric
            },
            value: {
                required,
                numeric
            },
            purchaseOrder: {},
            purchaseOrderDate: {
                required: requiredIf(function (model) {
                    return model.purchaseOrder && model.purchaseOrder.trim() !== "";
                })
            }
        },
        manualCompany: {
            taxNumber: {
                minLength: minLength(12),
                maxLength: maxLength(12),
                numeric
            },
            phone: {
                required,
                validPhone(value) {
                    return isValidPhone(value);
                }
            }
        },
    },
    components: {
        appNewBreadcrumb: Breadcrumb,
        appSelect: Select,
    },
    computed: {
        ...mapGetters(["getIsAdminOrModerator"]),
        proFormaFee_showLegalEntityStatus() {
            return this.proFormaInvoiceFees.jib != null && this.proFormaInvoiceFees.jib.length == 13;
        },
        proFormaFee_showLegalEntityNameOrError() {
            return this.legalEntityName != null && this.$v.proFormaInvoiceFees.jib.$dirty && this.$v.proFormaInvoiceFees.jib.numeric && this.$v.proFormaInvoiceFees.jib.minLength && this.$v.proFormaInvoiceFees.jib.maxLength && this.$v.proFormaInvoiceFees.jib.required;
        },
        totalValue() {
            if (this.proFormaInvoiceFees.type === 'M')
                this.proFormaInvoiceFees.value = 5;

            if (this.proFormaInvoiceFees.type === 'T')
                this.proFormaInvoiceFees.quantity = 1;

            let total = this.proFormaInvoiceFees.value * this.proFormaInvoiceFees.quantity;

            return total.toLocaleString('de');
        },
        proFormaJibIsValid() {
            const jib = this.proFormaInvoiceFees.jib;
            return (
                !!jib &&
                jib.length === 13 &&
                /^\d+$/.test(jib)
            );
        },
        proFormaHasAnyQuantity() {
            return this.proFormaInvoiceFees.quantity > 0 && this.proFormaInvoiceFees.value > 0;
        },
        manualCompanyValid() {
            if (!this.shouldShowManualCompanyFields) return true;

            const m = this.manualCompany;
            const requiredOk =
                !!m.legalEntityName &&
                !!m.address &&
                !!m.municipality &&
                !!m.taxNumber &&
                !!m.phone;

            if (!requiredOk) return false;

            const taxOk = /^\d{12}$/.test(m.taxNumber);

            const phoneOk = this.manualPhoneIsValid();

            return taxOk && phoneOk;
        },

        canDownloadProForma() {
            const baseOk =
                this.proFormaJibIsValid &&
                !!this.proFormaInvoiceFees.type &&
                this.proFormaHasAnyQuantity &&
                !this.$v.proFormaInvoiceFees.purchaseOrderDate.$error &&
                !this.isLookupLoading;

            if (!baseOk) return false;

            if (this.shouldShowManualCompanyFields) {
                return this.manualCompanyValid;
            }

            return true;
        },
        shouldShowManualCompanyFields() {
            return this.legalEntityLookupStatus === "not_found";
        },
        isLookupLoading() {
            return this.legalEntityLookupStatus === "loading";
        },
        estimateCompanyNamePlaceholder() {
            if (!this.estimate.jib) return this.$t('name');
            if (this.estimateLookupStatus === "loading") return this.$t('loadingCompanyData');
            if (this.estimateLookupStatus === "not_found") return this.$t('companyNameNotAvailable');
            if (this.estimateLookupStatus === "error") return this.$t('companyNameNotAvailable');
            return this.$t('name');
        },
    },
    methods: {
        ...mapActions(["fetchLegalEntities", "fetchEstimateByNumber", "generateEstimateFee", "fetchEstimateTypes"]),
        clearEstimateObject() {
            this.estimate.jib = null;
            this.estimate.legalEntityId = null;
            this.estimate.downloadDate = null;
            this.estimate.legalEntityName = null;
            this.estimate.estimateNumber = null;
            this.estimate.type = null;
            this.estimate.estimateTypeId = null;

            this.estimateLookupStatus = "idle";
            this.estimateLookupReqId = 0;
            this.estimateNumberReqId = 0;


            if (this.$v)
                this.$v.$reset();
        },
        clearproFormaInvoiceFeesObject() {
            this.proFormaInvoiceFees.jib = null;
            this.proFormaInvoiceFees.type = null
            this.proFormaInvoiceFees.quantity = null
            this.proFormaInvoiceFees.value = null
            this.proFormaInvoiceFees.purchaseOrder = null
            this.proFormaInvoiceFees.purchaseOrderDate = null

            this.legalEntityLookupStatus = "idle";
            this.manualTouched = false;
            this.manualCompany = {
                legalEntityName: null,
                address: null,
                municipality: null,
                taxNumber: null,
                phone: null,
            };

            if (this.$v)
                this.$v.$reset();
        },
        // estimateNumberChanged() {
        //     if (!this.getIsAdminOrModerator)
        //         return;

        //     this.estimate.jib = null;
        //     this.estimate.legalEntityId = null;
        //     this.estimate.legalEntityName = null;
        //     this.estimate.downloadDate = null;
        //     this.estimate.type = null;

        //     this.fetchEstimateByNumber({ estimateNumber: this.estimate.estimateNumber }).then((data) => {
        //         if (data) {
        //             this.estimate.jib = data.jib;
        //             this.estimate.estimateTypeId = data.estimateTypeId;
        //             if (data.downloadDate) {
        //                 const date = new Date(data.downloadDate);
        //                 this.estimate.downloadDate = date.toLocaleDateString('de');
        //             } else {
        //                 this.estimate.downloadDate = null;
        //             }
        //             if (this.estimate.jib) {
        //                 this.fetchLegalEntities({ jib: this.estimate.jib }).then((data) => {
        //                     if (data.resultList && data.resultList.length > 0) {
        //                         this.estimate.legalEntityName = data.resultList[0].shortName || data.resultList[0].longName;
        //                         this.estimate.legalEntityId = data.resultList[0].id;
        //                     }
        //                 });
        //             }
        //             if (this.estimate.estimateTypeId) {
        //                 this.fetchEstimateTypes({ id: this.estimate.estimateTypeId }).then((data) => {
        //                     this.estimate.type = data.name;
        //                 });
        //             }

        //         }
        //     });
        // },
        estimateNumberChanged() {
            if (!this.getIsAdminOrModerator) return;

            this.estimate.jib = null;
            this.estimate.legalEntityId = null;
            this.estimate.legalEntityName = null;
            this.estimate.downloadDate = null;
            this.estimate.type = null;
            this.estimate.estimateTypeId = null;

            this.estimateLookupStatus = "idle";

            const estimateReqId = ++this.estimateNumberReqId;
            const estimateNumber = this.estimate.estimateNumber;

            this.fetchEstimateByNumber({ estimateNumber })
                .then((data) => {
                    if (estimateReqId !== this.estimateNumberReqId) return;
                    if (!data) return;

                    this.estimate.jib = data.jib || null;
                    this.estimate.estimateTypeId = data.estimateTypeId || null;

                    if (data.downloadDate) {
                        const date = new Date(data.downloadDate);
                        this.estimate.downloadDate = date.toLocaleDateString('de');
                    } else {
                        this.estimate.downloadDate = null;
                    }

                    if (this.estimate.estimateTypeId) {
                        this.fetchEstimateTypes({ id: this.estimate.estimateTypeId })
                            .then((t) => {
                                if (estimateReqId !== this.estimateNumberReqId) return;
                                this.estimate.type = t?.name || null;
                            })
                            .catch(() => {
                                if (estimateReqId !== this.estimateNumberReqId) return;
                                this.estimate.type = null;
                            });
                    }

                    if (!this.estimate.jib) return;

                    this.estimateLookupStatus = "loading";
                    const lookupReqId = ++this.estimateLookupReqId;
                    const jib = this.estimate.jib;

                    this.fetchLegalEntities({ jib })
                        .then((le) => {
                            if (lookupReqId !== this.estimateLookupReqId) return;
                            if (estimateReqId !== this.estimateNumberReqId) return;

                            if (le?.resultList?.length > 0) {
                                const row = le.resultList[0];
                                this.estimate.legalEntityName = row.shortName || row.longName || null;
                                this.estimate.legalEntityId = row.id || null;
                                this.estimateLookupStatus = "found";
                            } else {
                                this.estimate.legalEntityName = null;
                                this.estimate.legalEntityId = null;
                                this.estimateLookupStatus = "not_found";
                            }
                        })
                        .catch(() => {
                            if (lookupReqId !== this.estimateLookupReqId) return;
                            if (estimateReqId !== this.estimateNumberReqId) return;

                            this.estimate.legalEntityName = null;
                            this.estimate.legalEntityId = null;
                            this.estimateLookupStatus = "error";
                        });
                })
                .catch(() => {
                    if (estimateReqId !== this.estimateNumberReqId) return;
                    this.estimateLookupStatus = "idle";
                });
        },
        // downloadEstimate() {
        //     if (this.$v.proFormaInvoiceFees.$invalid) {
        //         this.$v.proFormaInvoiceFees.$touch();
        //         return;
        //     }
        //     this.showSpinner = true;
        //     this.isLoading = true;

        //     const payload = {
        //         jib: this.proFormaInvoiceFees.jib,
        //         type: this.proFormaInvoiceFees.type,
        //         quantity: this.proFormaInvoiceFees.quantity,
        //         value: this.proFormaInvoiceFees.value,
        //         purchaseOrder: this.proFormaInvoiceFees.purchaseOrder,
        //         purchaseOrderDate: this.proFormaInvoiceFees.purchaseOrderDate
        //             ? new Date(this.proFormaInvoiceFees.purchaseOrderDate).toLocaleDateString('de-DE')
        //             : null
        //     };
        //     this.generateEstimateFee(payload)
        //         .then((excelTemplate) => {
        //             const url = URL.createObjectURL(new Blob([excelTemplate.data]));
        //             const link = document.createElement('a');
        //             link.href = url;
        //             link.setAttribute('download', `Predračun - ${this.proFormaInvoiceFees.jib}.docx`);
        //             document.body.appendChild(link);
        //             link.click();
        //             document.body.removeChild(link);

        //             this.clearproFormaInvoiceFeesObject();
        //             this.$bvModal.hide('modal-container-fee');

        //             this.showSpinner = false;
        //             this.isLoading = false;
        //         })
        //         .catch((err) => {
        //             this.showSpinner = false;
        //             this.isLoading = false;
        //         });
        // },
        async downloadEstimate() {
            if (this.isLoading) return;

            if (this.$v.proFormaInvoiceFees.$invalid) {
                this.$v.proFormaInvoiceFees.$touch();
                return;
            }

            if (this.legalEntityLookupStatus === "not_found" && !this.manualCompanyValid) {
                this.manualTouched = true;
                return;
            }

            if (this.legalEntityLookupStatus === "not_found") {
                if (!this.manualCompanyValid) {
                    this.manualTouched = true;

                    return;
                }

                const confirmed = await this.$bvModal.msgBoxConfirm(
                    this.$t('confirmManualEntry'),
                    {
                        title: this.$t('checkJIB'),
                        okTitle: this.$t('confirm'),
                        cancelTitle: this.$t('checkAgain'),
                        centered: true
                    }
                );

                if (!confirmed) return;
            }

            this._downloadEstimateSend();
        },
        _downloadEstimateSend() {
            this.showSpinner = true;
            this.isLoading = true;

            const payload = {
                jib: this.proFormaInvoiceFees.jib,
                type: this.proFormaInvoiceFees.type,
                quantity: this.proFormaInvoiceFees.quantity,
                value: this.proFormaInvoiceFees.value,
                purchaseOrder: this.proFormaInvoiceFees.purchaseOrder,
                purchaseOrderDate: this.proFormaInvoiceFees.purchaseOrderDate
                    ? new Date(this.proFormaInvoiceFees.purchaseOrderDate).toLocaleDateString('de-DE')
                    : null,

                legalEntityName: this.manualCompany.legalEntityName,
                address: this.manualCompany.address,
                municipality: this.manualCompany.municipality,
                taxNumber: this.manualCompany.taxNumber,
                phone: this.manualCompany.phone,
            };

            this.generateEstimateFee(payload)
                .then((docx) => {
                    const url = URL.createObjectURL(new Blob([docx.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `Predračun - ${this.proFormaInvoiceFees.jib}.docx`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    this.clearproFormaInvoiceFeesObject();
                    this.$bvModal.hide('modal-container-fee');

                    this.showSpinner = false;
                    this.isLoading = false;
                })
                .catch(() => {
                    this.showSpinner = false;
                    this.isLoading = false;
                });
        },
        async proFormaInvoiceFeesJibChanged() {

            this.legalEntityName = null;
            this.legalEntityId = null;

            this.manualTouched = false;
            this.manualCompany = {
                legalEntityName: null,
                address: null,
                municipality: null,
                taxNumber: null,
                phone: null,
            };

            if (!this.proFormaJibIsValid) {
                this.legalEntityLookupStatus = "idle";
                return;
            }

            this.legalEntityLookupStatus = "loading";

            try {
                const data = await this.fetchLegalEntities({ jib: this.proFormaInvoiceFees.jib });

                if (data?.resultList?.length > 0) {
                    this.legalEntityName = data.resultList[0].shortName || data.resultList[0].longName;
                    this.legalEntityId = data.resultList[0].id;
                    this.legalEntityLookupStatus = "found";
                } else {
                    this.legalEntityLookupStatus = "not_found";
                }
            } catch (e) {
                this.legalEntityLookupStatus = "error";
            }

            // if (this.proFormaInvoiceFees.jib.length == 13) {
            //     this.fetchLegalEntities({ jib: this.proFormaInvoiceFees.jib }).then((data) => {
            //         if (data.resultList != null && data.resultList.length > 0) {
            //             this.legalEntityName = data.resultList[0].shortName || data.resultList[0].longName;
            //             this.legalEntityId = data.resultList[0].id;
            //         }
            //     });
            // }
        },
        onTaxNumberChanged() {
            const v = (this.manualCompany.taxNumber || "").toString();
            this.manualCompany.taxNumber = v.replace(/\D+/g, "");

            if (this.$v && this.$v.manualCompany && this.$v.manualCompany.taxNumber)
                this.$v.manualCompany.taxNumber.$touch();
        },
        manualTaxNumberIsValid() {
            const tax = (this.manualCompany.taxNumber || "").toString();
            return /^\d{12}$/.test(tax);
        },
        onPhoneChanged() {
            const v = (this.manualCompany.phone || "").toString();

            this.manualCompany.phone = v.replace(/[^\d+\s\-\/()]+/g, "");

            if (this.$v && this.$v.manualCompany && this.$v.manualCompany.phone)
                this.$v.manualCompany.phone.$touch();
        },

        manualPhoneIsValid() {
            const phone = (this.manualCompany.phone || "").toString();
            if (!phone) return false;

            const digits = phone.replace(/\D+/g, "");

            return digits.length === 9 || digits.length === 10;
        },
    },
    watch: {
        'proFormaInvoiceFees.type'(newType) {
            if (!newType) return;

            if (newType === 'T') {
                this.proFormaInvoiceFees.quantity = 1;
                this.proFormaInvoiceFees.value = null;
            } else if (newType === 'M') {
                this.proFormaInvoiceFees.quantity = null;
                this.proFormaInvoiceFees.value = 5;
            } else {
                this.proFormaInvoiceFees.quantity = null;
                this.proFormaInvoiceFees.value = null;
            }
        }
    }
}
</script>

<style scoped>
.big-card-title h3 {
    margin-bottom: 0;
}

.denomination-label {
    font-weight: 600;
}

.quantity-input {
    display: flex;
    flex-direction: column;
}
</style>
